import { logSentry } from '@gto/sentry'

/**
 * Shared boundary coercion for affiliate money fields. The BE serialises
 * Decimal money as STRINGS on the wire (e.g. "12500.75"); call sites need real
 * `number`s for math and formatters. A non-numeric/NaN input is a BE contract
 * violation — render 0 rather than crash `FormattedNumber` / `.toFixed`, but
 * surface the breach via `logSentry` so a silent $0.00 doesn't pass as truth.
 *
 * `logPrefix` identifies the surface (e.g. `'dashboard toAmount:'`) so a Sentry
 * grep distinguishes which page tripped the contract. The settlements
 * `select`-time mapper keeps its own `toAmount` because it routes through a
 * single boundary already; this helper is the shared form for the inline
 * `Number(stats?.x ?? 0)` sites on the dashboard / reports / partner-detail
 * KPI tiles.
 */
export const toAmount = (value: number | string | null | undefined, logPrefix: string): number => {
  if (value == null) {
    return 0
  }
  const n = Number(value)

  if (!Number.isFinite(n)) {
    logSentry(logPrefix, { value })

    return 0
  }

  return n
}
